const locale_de = {
    bandContent: 'Inhalt',
    bandFooter: 'Fußzeile',
    bandHeader: 'Kopfzeile',
    clear: 'Löschen',
    contentHeight: 'Inhaltshöhe',
    contentHeightInfo: 'Höhe des Inhaltsbereichs, um Elemente zu platzieren (betrifft nicht die tatsächliche Seitengröße)',
    differentFiles: 'versch. Dateien...',
    differentValues: 'versch. Werte...',
    docElementAlignToPageBottom: 'Am unteren Seitenrand ausrichten',
    docElementAlternateBackgroundColor: 'Abwechselnde Hintergrundfarbe',
    docElementAlwaysPrintOnSamePage: 'Immer zusammen auf einer Seite',
    docElementBarCode: 'Barcode',
    docElementBarWidth: 'Balkenbreite',
    docElementBorderFrame: 'außen',
    docElementBorderFrameRow: 'Rahmen und Zeile',
    docElementBorderGrid: 'Alle Rahmenlinien',
    docElementBorderNone: 'Keiner',
    docElementBorderRow: 'Zeilen',
    docElementColor: 'Farbe',
    docElementColspan: 'Anz. verbundene Zellen',
    docElementColumns: 'Spalten',
    docElementConditionalStyle: 'Bedingte Formatierung',
    docElementConditionalStyleCondition: 'Bedingung',
    docElementContent: 'Text',
    docElementContentRows: 'Inhaltszeilen',
    docElementDataSource: 'Datenquelle',
    docElementDisplayValue: 'Wert anzeigen',
    docElementErrorCorrectionLevel: 'Fehlerkorrektur',
    docElementErrorCorrectionLevelHigh: 'Hoch',
    docElementErrorCorrectionLevelLow: 'Niedrig',
    docElementErrorCorrectionLevelMedium: 'Mittel',
    docElementErrorCorrectionLevelQuartile: 'Quartil',
    docElementEval: 'Auswerten',
    docElementFormat: 'Format',
    docElementFrame: 'Rahmen',
    docElementGroupExpression: 'Gruppen Ausdruck',
    docElementGrowWeight: 'Wachstums-Gewicht',
    docElementGrowWeightInfo: 'Wachstumsfaktor zur Verwendung des Platzes von ausgeblendeten Spalten',
    docElementGrowWeightHigh: 'hoch',
    docElementGrowWeightLow: 'niedrig',
    docElementGuardBar: 'Rand-/Trennzeichen',
    docElementHeight: 'Höhe',
    docElementImage: 'Bild',
    docElementImageFile: 'Bilddatei',
    docElementLabel: 'Bezeichnung',
    docElementLine: 'Linie',
    docElementLink: 'Link',
    docElementLoadImageErrorMsg: 'Bild laden fehlgeschlagen',
    docElementPageBreak: 'Seitenumbruch',
    docElementPattern: 'Pattern',
    docElementPosition: 'Position (x, y)',
    docElementPositionX: 'Position (x)',
    docElementPositionY: 'Position (y)',
    docElementPrintIf: 'Anzeigen wenn',
    docElementPrintSettings: 'Anzeige',
    docElementRemoveEmptyElement: 'Entfernen wenn nicht vorhanden',
    docElementRepeatGroupHeader: 'Gruppe auf jeder Seite wiederholen',
    docElementRepeatHeader: 'Auf jeder Seite wiederholen',
    docElementRichText: 'Rich Text',
    docElementRoot: 'Dokument',
    docElementRotate: 'Drehen',
    docElementSection: 'Sektion',
    docElementShrinkToContentHeight: 'Auf Inhaltshöhe reduzieren',
    docElementSize: 'Größe (Breite, Höhe)',
    docElementSource: 'Bildquelle',
    docElementSpreadsheet: 'Tabellenkalkulation',
    docElementSpreadsheetAddEmptyRow: 'Leere Zeile unterhalb einfügen',
    docElementSpreadsheetColspan: 'Anz. verbundene Zellen',
    docElementSpreadsheetColumn: 'Fixe Spalte',
    docElementSpreadsheetHide: 'Ausblenden',
    docElementSpreadsheetTextWrap: 'Zeilenumbruch',
    docElementStyle: 'Formatvorlage',
    docElementTable: 'Tabelle',
    docElementTableBandPageBreak: 'Seitenumbruch mit jeder neuen Gruppe',
    docElementText: 'Text',
    docElementWidth: 'Breite',
    documentProperties: 'Dokumenteinstellungen',
    documentTabClose: 'Schließen',
    documentTabPdfLayout: 'PDF Layout',
    documentTabPdfPreview: 'PDF Vorschau',
    documentTabXlsxDownload: 'XLSX Download',
    emptyPanel: 'Leer',
    errorMsgDuplicateParameter: 'Parameter existiert bereits',
    errorMsgDuplicateParameterField: 'Feld existiert bereits',
    errorMsgFontNotAvailable: 'Schrift ist am Server nicht vorhanden',
    errorMsgLoadingImageFailed: 'Bild laden fehlgeschlagen: ${info}',
    errorMsgInvalidArray: 'Ungültige Liste',
    errorMsgInvalidAvgSumExpression: 'Ausdruck muss ein Zahl-Feld einer Liste enthalten',
    errorMsgInvalidBarCode: 'Ungültiger Barcode Inhalt',
    errorMsgInvalidDataSource: 'Ungültige Datenquelle',
    errorMsgInvalidDataSourceParameter: 'Parameter muss eine Liste sein',
    errorMsgInvalidDate: 'Ungültiges Datum, erwartetes Format ist JJJJ-MM-TT (bzw. JJJJ-MM-TT hh:mm für Datum mit Uhrzeit)',
    errorMsgInvalidStringData: 'Ungültiger Inhalt für Text Parameter ${info}',
    errorMsgInvalidExpression: 'Ungültiger Ausdruck: ${info}',
    errorMsgInvalidExpressionFuncNotDefined: 'Funktion ${info} ist nicht definiert',
    errorMsgInvalidExpressionNameNotDefined: 'Name ${info} ist nicht definiert',
    errorMsgInvalidExpressionType: 'Ausdruck liefert ungültigen Typ',
    errorMsgInvalidLink: 'Link muss mit http:// oder https:// beginnen',
    errorMsgInvalidImage: 'Ungültige Bilddaten, Bild muss base64 kodiert sein',
    errorMsgInvalidImageSource: 'Ungültige Bildquelle, Url beginnend mit http:// bzw. https:// erwartet',
    errorMsgInvalidImageSourceParameter: 'Parameter vom Typ Bild oder String (mit einer Url) notwendig',
    errorMsgInvalidMap: 'Ungültige Auflistung',
    errorMsgInvalidNumber: 'Ungültige Zahl',
    errorMsgInvalidPageSize: 'Ungültige Seitengröße',
    errorMsgInvalidParameterData: 'Daten stimmen nicht mit Parameter überein',
    errorMsgInvalidParameterName: 'Name muss mit einem Zeichen oder Unterstrich beginnen und darf nur Zeichen, Ziffern und Unterstriche enthalten',
    errorMsgInvalidPattern: 'Ungültiges Pattern',
    errorMsgInvalidPosition: 'Die Position ist außerhalb des Bereichs',
    errorMsgInvalidSize: 'Das Element ist außerhalb des Bereichs',
    errorMsgInvalidTestData: 'Ungültige Testdaten',
    errorMsgMissingData: 'Fehlende Daten',
    errorMsgMissingDataSourceParameter: 'Datenquelle Parameter nicht gefunden',
    errorMsgMissingExpression: 'Ausdruck muss gesetzt sein',
    errorMsgMissingImage: 'Fehlendes Bild: Keine Bildquelle oder -datei angegeben',
    errorMsgMissingParameter: 'Parameter nicht gefunden',
    errorMsgMissingParameterData: 'Daten für Parameter {info} nicht gefunden',
    errorMsgRepeatGroupHeaderAfterContent: 'Nicht erlaubt für Gruppe nach Inhaltszeile',
    errorMsgPlusVersionRequired: 'Benötigt kommerzielle PLUS Version',
    errorMsgSectionBandNotOnSamePage: 'Abschnittsbereich passt nicht auf eine Seite',
    errorMsgSectionBandPageBreakNotAllowed: 'Manueller Seitenumbruch ist nicht erlaubt',
    errorMsgUnicodeEncodeError: 'Text enthält nicht druckbare Zeichen',
    errorMsgUnsupportedImageType: 'Bildtyp wird nicht unterstützt (nur .jpg und .png erlaubt)',
    footer: 'Fußzeile',
    footerDisplay: 'Anzeige',
    footerSize: 'Höhe Fußzeile',
    header: 'Kopfzeile',
    headerDisplay: 'Anzeige',
    headerFooterDisplayAlways: 'Immer',
    headerFooterDisplayNotOnFirstPage: 'Nicht auf erster Seite',
    headerSize: 'Höhe Kopfzeile',
    menuColumnAddLeft: 'Spalte links hinzufügen',
    menuColumnAddRight: 'Spalte rechts hinzufügen',
    menuColumnDelete: 'Spalte löschen',
    menuAlignBottom: 'Unten ausrichten',
    menuAlignCenter: 'Zentriert ausrichten',
    menuAlignLeft: 'Links ausrichten',
    menuAlignMiddle: 'Mittig ausrichten',
    menuAlignRight: 'Rechts ausrichten',
    menuAlignTop: 'Oben ausrichten',
    menuInsertReport: 'EINF.',
    menuInsertReportTip: 'Report-Vorlage einfügen',
    menuLogReport: 'LOG',
    menuLogReportTip: 'Report-Vorlage in Konsole ausgeben',
    menuPreview: 'VORSCHAU',
    menuPreviewTip: 'Report-Vorschau',
    menuRedo: 'WIEDERH.',
    menuRedoTip: 'Letzten rückgängig gemachten Befehl wiederholen',
    menuRowAddAbove: 'Zeile oberhalb hinzufügen',
    menuRowAddBelow: 'Zeile unterhalb hinzufügen',
    menuRowDelete: 'Zeile löschen',
    menuSave: 'SPEICHERN',
    menuSaveTip: 'Report speichern',
    menuToggleGrid: 'Raster ein-/ausblenden',
    menuUndo: 'RÜCKG.',
    menuUndoTip: 'Letzten Befehl rückgängig machen',
    menuZoomIn: 'Vergrößern',
    menuZoomOut: 'Verkleinern',
    nameCopySuffix: 'Kopie',
    orientation: 'Ausrichtung',
    orientationBottom: 'unten',
    orientationLandscape: 'Querformat',
    orientationLeft: 'links',
    orientationPortrait: 'Hochformat',
    orientationRight: 'rechts',
    orientationTop: 'oben',
    pageFormat: 'Seitenformat',
    pageFormatA4: 'DIN A4 (210 x 297 mm)',
    pageFormatA5: 'DIN A5 (148 x 210 mm)',
    pageFormatLetter: 'Brief (216 x 279 mm)',
    pageFormatUserDefined: 'Eigene Einstellung',
    pageHeight: 'Höhe',
    pageMargins: 'Seitenränder',
    pageWidth: 'Breite',
    parameter: 'Parameter',
    parameterAddTestData: 'Zeile hinzufügen',
    parameterArrayItemType: 'Listenelement-Typ',
    parameterEditTestData: 'Bearbeiten',
    parameterEditTestDataNoFields: 'Keine Felder für diese Liste definiert',
    parameterEval: 'Text auswerten',
    parameterExpression: 'Ausdruck',
    parameterListType: 'Listen-Typ',
    parameterName: 'Name',
    parameterNullable: 'NULL-Wert erlaubt',
    parameterPattern: 'Pattern',
    parameterRowParams: 'Parameter in Zeile',
    parameterSearchPlaceholder: 'Parameter durchsuchen...',
    parameterTestData: 'Testdaten',
    parameterTestDataDatePattern: 'JJJJ-MM-TT',
    parameterTestDataImageInfo: 'Bilder werden in der Berichtsvorlage gespeichert und können die Größe der Berichtsvorlage erheblich erhöhen',
    parameterTestDataRowCount: '${count} Zeilen',
    parameterTestDataRowCountEmpty: 'leer',
    parameterTestDataRowCountOne: '1 Zeile',
    parameterType: 'Typ',
    parameterTypeArray: 'Liste',
    parameterTypeAverage: 'Durchschnitt',
    parameterTypeBoolean: 'Boolean',
    parameterTypeDate: 'Datum',
    parameterTypeImage: 'Bild',
    parameterTypeMap: 'Gruppierung',
    parameterTypeNumber: 'Zahl',
    parameterTypeSimpleArray: 'Einfache Liste',
    parameterTypeString: 'String',
    parameterTypeSum: 'Summe',
    parameters: 'Parameter',
    parametersDataSource: 'Datenquelle Parameter',
    patternCurrencySymbol: 'Währungssymbol',
    patternDate1: 'Tag.Monat.Jahr, z.B. 1.6.1980',
    patternDate2: 'Tag.Monat.Jahr (2-stellig), Stunde(24h):Minute, z.B. 1.6.80, 14:30',
    patternDate3: 'Tag/Monat/Jahr (Monat abgekürzt), z.B. 1/Jun/1980',
    patternDate4: 'Monat/Tag/Jahr (Tag und Monat mit führender Null, falls einstellig), z.B. 06/01/1980',
    patternLocale: 'Pattern Locale',
    patternNumber1: 'Tausender-Trennzeichen',
    patternNumber2: 'Dezimalpunkt gefolgt von 3 Dezimalstellen',
    patternNumber3: 'Dezimalpunkt gefolgt von mind. 2 und max. 4 Dezimalstellen',
    patternNumber4: 'Tausender-Trennzeichen und Dezimalpunkt gefolgt von 2 Dezimalstellen',
    patternNumber5: 'Währungssymbol vor Zahl',
    patternNumberGroupSymbol: 'Tausender-Trennzeichen',
    patternNumberGroupSymbolInfo: 'leer lassen für Standardzeichen',
    patternSeparatorDates: '--- Datum Pattern ---',
    patternSeparatorNumbers: '--- Zahlen Pattern ---',
    plusFeatureInfo: 'Benötigt kommerzielle <a href="https://www.reportbro.com/license/index" target="_blank" rel="noreferrer">PLUS Version</a>',
    plusFeatureInfoNestedParameter: 'Verschachtelter Parameter benötigt kommerzielle <a href="https://www.reportbro.com/license/index" target="_blank" rel="noreferrer">PLUS Version</a>',
    select: 'auswählen...',
    style: 'Formatvorlage',
    styleAlignment: 'Ausrichtung',
    styleBackgroundColor: 'Hintergrundfarbe',
    styleBold: 'Fett',
    styleBorder: 'Rahmen',
    styleBorderAll: 'vollständig',
    styleBorderColor: 'Rahmenfarbe',
    styleBorderWidth: 'Rahmenbreite',
    styleFont: 'Schrift',
    styleFontSizeUnit: 'pt',
    styleHAlignmentCenter: 'Zentriert',
    styleHAlignmentLeft: 'Links',
    styleHAlignmentJustify: 'Blocksatz',
    styleHAlignmentRight: 'Rechts',
    styleItalic: 'Kursiv',
    styleLineSpacing: 'Linienabstand',
    styleName: 'Name',
    styleNone: 'Keine',
    stylePadding: 'Innenabstand',
    styleStrikethrough: 'Durchgestrichen',
    styleTextColor: 'Textfarbe',
    styleTextStyle: 'Formatierung',
    styleUnderline: 'Unterstreichen',
    styleVAlignmentBottom: 'Unten',
    styleVAlignmentMiddle: 'Mittig',
    styleVAlignmentTop: 'Oben',
    styles: 'Formatvorlagen'
};

export default locale_de;
